<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000">
        <span>{{snackbar_message}}</span>
      </v-snackbar>
      
      <v-card class="neu-glow elevation-8 pb-5">
        <v-card-title primary-title>
          <div class="text-h5">Impostazioni Newsletter Widget</div>
          <v-spacer></v-spacer>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </div>
        </v-card-title>

        <v-row v-if="loading">
          <v-col class="text-center">
            <v-progress-linear color="info" height="10" indeterminate striped></v-progress-linear>
          </v-col>
        </v-row>

        <v-row v-else class="mx-5">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Widget Settings -->
          <v-col cols="12" md="6">
            <v-card class="neu-glow">
              <v-card-title class="text-h6 mb-3 blue white--text">
                Configurazione Widget
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon fab small class="neu-glow mr-2" 
                      :loading="loading_update" 
                      :disabled="config_hash===JSON.stringify(widgetConfig)" 
                      @click.stop="saveConfig()">
                      <v-icon color="white">mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <span>Salva Configurazione</span>
                </v-tooltip>
              </v-card-title>
              
              <v-card-text>
                <v-row>
                  <!-- Display Mode Selection -->
                  <v-col cols="12">
                    <div class="text-subtitle-1 font-weight-bold mb-3">Modalità di Visualizzazione</div>
                    <v-item-group v-model="widgetConfig.displayMode" mandatory>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-item value="inline" v-slot="{ active, toggle }">
                            <v-card
                              :color="active ? 'blue' : ''"
                              :dark="active"
                              @click="toggle"
                              class="d-flex align-center"
                              height="140"
                              hover
                            >
                              <v-card-text class="text-center">
                                <v-icon size="48" :color="active ? 'white' : 'blue'">
                                  mdi-page-layout-body
                                </v-icon>
                                <div class="mt-2 font-weight-bold">Inline</div>
                                <div class="text-caption" :class="active ? 'white--text' : 'grey--text'">
                                  Incorporato nella pagina
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-item>
                        </v-col>
                        
                        <v-col cols="12" md="4">
                          <v-item value="auto-popup" v-slot="{ active, toggle }">
                            <v-card
                              :color="active ? 'blue' : ''"
                              :dark="active"
                              @click="toggle"
                              class="d-flex align-center"
                              height="140"
                              hover
                            >
                              <v-card-text class="text-center">
                                <v-icon size="48" :color="active ? 'white' : 'blue'">
                                  mdi-clock-alert-outline
                                </v-icon>
                                <div class="mt-2 font-weight-bold">Popup Automatico</div>
                                <div class="text-caption" :class="active ? 'white--text' : 'grey--text'">
                                  Appare dopo X secondi
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-item>
                        </v-col>
                        
                        <v-col cols="12" md="4">
                          <v-item value="button-popup" v-slot="{ active, toggle }">
                            <v-card
                              :color="active ? 'blue' : ''"
                              :dark="active"
                              @click="toggle"
                              class="d-flex align-center"
                              height="140"
                              hover
                            >
                              <v-card-text class="text-center">
                                <v-icon size="48" :color="active ? 'white' : 'blue'">
                                  mdi-cursor-pointer
                                </v-icon>
                                <div class="mt-2 font-weight-bold">Popup su Click</div>
                                <div class="text-caption" :class="active ? 'white--text' : 'grey--text'">
                                  Attivato da pulsante
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-item>
                        </v-col>
                      </v-row>
                    </v-item-group>
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>

                  <!-- Widget Content -->
                  <v-col cols="6">
                    <v-text-field
                      v-model="widgetConfig.title"
                      label="Titolo Widget"
                      outlined
                      dense
                      hint="Titolo mostrato nel widget"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="widgetConfig.privacyUrl"
                      label="URL Privacy Policy *"
                      outlined
                      dense
                      hint="Il link deve iniziare con https://"
                      persistent-hint
                      :rules="[
                        v => !!v || 'URL Privacy Policy richiesto',
                        v => (v && v.startsWith('https://')) || 'Deve iniziare con https://'
                      ]"
                      :append-icon="privacyUrlValid ? 'mdi-check-circle' : 'mdi-alert-circle'"
                      :color="privacyUrlValid ? 'success' : 'error'"
                      @blur="validatePrivacyUrl"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="widgetConfig.description"
                      label="Descrizione"
                      outlined
                      dense
                      rows="3"
                      hint="Testo descrittivo mostrato nel widget"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" md="4">
                    <v-text-field
                      v-model="widgetConfig.buttonText"
                      label="Testo Pulsante Invio"
                      outlined
                      dense
                      hint="Testo del pulsante di invio del form"
                      persistent-hint
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" md="4">
                    <v-text-field
                      v-model="widgetConfig.buttonColor"
                      label="Colore Pulsante"
                      outlined
                      dense
                      type="color"
                      hint="Colore del pulsante (hex)"
                      persistent-hint
                    ></v-text-field>
                  </v-col>


                  <!-- Auto Popup Delay -->
                  <v-col cols="4" v-if="widgetConfig.displayMode === 'auto-popup'">
                    <v-text-field
                      v-model.number="widgetConfig.popupDelay"
                      label="Ritardo Popup (secondi)"
                      outlined
                      dense
                      type="number"
                      min="1"
                      max="60"
                      hint="Numero di secondi prima che il popup appaia automaticamente"
                      persistent-hint
                    ></v-text-field>
                  </v-col>                  

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>

                  <!-- Field Options -->
                  <v-col cols="12">
                    <div class="text-subtitle-1 font-weight-bold mb-2">Opzioni Campi</div>
                  </v-col>

                  <v-col cols="6" class="py-0">
                    <v-switch
                      v-model="widgetConfig.requireEmail"
                      color="blue"
                      label="Email Obbligatoria"
                      hint="Se attivo, l'email diventa campo obbligatorio"
                      persistent-hint
                    ></v-switch>
                  </v-col>

                  <v-col cols="6" class="py-0">
                    <v-switch
                      v-model="widgetConfig.showGender"
                      color="blue"
                      label="Mostra Campo Sesso"
                      hint="Se attivo, mostra il campo per selezionare il sesso"
                      persistent-hint
                    ></v-switch>
                  </v-col>

                  <v-col cols="12" class="text-center mt-4">
                    <v-btn
                      large
                      color="success"
                      :disabled="config_hash===JSON.stringify(widgetConfig)"
                      :loading="checkingPrivacyUrl"
                      @click="openEmbedDialog"
                    >
                      <v-icon left>mdi-code-tags</v-icon>
                      Genera Codice di Integrazione
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>

                  <!-- Field Options -->
                <v-col cols="12" md="12">
                  <v-card class="neu-glow">
                    <v-card-title class="text-h6 mb-3 blue white--text">Opzioni Messaggio                   
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon fab small class="neu-glow mr-2" 
                            :loading="loading_update" 
                            @click.stop="saveConfig()">
                            <v-icon color="white">mdi-content-save</v-icon>
                          </v-btn>
                        </template>
                        <span>Salva Configurazione</span>
                      </v-tooltip>
                      </v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="6" class="py-0">
                    <v-switch
                      v-model="widgetConfig.sendWAWhenSubscribe"
                      color="blue"
                      label="Invia Messaggio all'Iscrizione"
                      hint="Se attivo, invia messaggio WhatsApp con seguente offerta all'iscrizione"
                      persistent-hint
                    ></v-switch>
                  </v-col>

                  <v-col cols="4" class="py-0">
                    <p>Qualora il cliente abbia ricevuto un "Bonus Newsletter" apparirà la seguente icona in iManager</p>
                    
                  </v-col>

                  <v-col cols="2" class="py-0">
                    <v-icon x-large>mdi-ticket</v-icon>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="widgetConfig.body1"
                      label="Testo del messaggio WhatsApp"
                      outlined
                      dense
                      auto-grow
                      :rows="3"
                      hint="1° Testo del messaggio WhatsApp"
                      persistent-hint
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="widgetConfig.body2"
                      label="Testo del messaggio WhatsApp"
                      outlined
                      dense
                      auto-grow
                      :rows="3"
                      hint="2° Testo del messaggio WhatsApp"
                      persistent-hint
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="widgetConfig.body3"
                      label="Testo del messaggio WhatsApp"
                      outlined
                      dense
                      auto-grow
                      :rows="3"
                      :disabled="!!(widgetConfig.link && widgetConfig.link.trim())"
                      hint="3° Testo del messaggio WhatsApp: Viene sovrascritto dal Link"
                      persistent-hint
                    ></v-textarea>
                  </v-col>                  

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="widgetConfig.link"
                      label="Link Offerta"
                      outlined
                      dense
                      :disabled="!!(widgetConfig.body3 && widgetConfig.body3.trim())"
                      hint="link Offerta: se presente sovrascrive il testo del terzo messaggio"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Widget Preview -->
          <v-col cols="12" md="6">
            <v-card class="neu-glow">
              <v-card-title class="text-h6 mb-3 blue white--text">
                Anteprima Widget
              </v-card-title>
              <v-card-text>
                <div class="newsletter-preview pa-4">
                  <h3 class="mb-2 black--text">{{ widgetConfig.title }}</h3>
                  <p class="text-body-2 mb-4 grey--text text--darken-2">{{ widgetConfig.description }}</p>
                  
                  <v-form ref="previewForm">
                    <v-text-field
                      v-model="preview.firstName"
                      label="Nome"
                      outlined
                      dense
                      class="mb-2"
                      :rules="[v => !!v || 'Nome richiesto']"
                    ></v-text-field>
                    
                    <v-text-field
                      v-model="preview.lastName"
                      label="Cognome"
                      outlined
                      dense
                      class="mb-2"
                      :rules="[v => !!v || 'Cognome richiesto']"
                    ></v-text-field>


                    <!-- WhatsApp Phone with Country Code -->
                    <v-row class="mb-2">
                      <v-col cols="5" class="py-0 pr-1">
                        <v-select
                          dense
                          outlined
                          v-model="preview.countryCode"
                          :items="widgetCountryCodes"
                          item-text="label"
                          item-value="code"
                          label="Prefisso"
                          hide-details
                        >
                          <template v-slot:selection="data">
                            {{ data.item.flag }} {{ data.item.code }}
                          </template>
                          <template v-slot:item="data">
                            {{ data.item.flag }} {{ data.item.label }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="7" class="py-0 pl-1">
                        <v-text-field
                          ref="phone"
                          prepend-inner-icon="mdi-whatsapp"
                          label="Numero WhatsApp"
                          v-model="preview.phone"
                          name="phone"
                          type="tel"
                          autocomplete="false"
                          reverse
                          hide-spin-buttons
                          outlined
                          dense
                          required
                          counter
                          persistent-hint
                          :rules="[v => !!v || 'Numero richiesto', v => /^[0-9]{6,15}$/.test(v) || 'Inserisci un numero valido']"
                          @input="validatePhone"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-text-field
                      v-model="preview.email"
                      :label="widgetConfig.requireEmail ? 'Email *' : 'Email (Opzionale)'"
                      outlined
                      dense
                      type="email"
                      class="mb-2"
                      :rules="widgetConfig.requireEmail ? [v => !!v || 'Email richiesta', v => /.+@.+\..+/.test(v) || 'Email non valida'] : [v => !v || /.+@.+\..+/.test(v) || 'Email non valida']"
                    ></v-text-field>

                    <v-menu
                      ref="birthdateMenu"
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedBirthdate"
                          label="Data di Nascita"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          prepend-inner-icon="mdi-calendar"
                          class="mb-2"
                          :rules="[v => !!v || 'Data di nascita richiesta']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="birthdatePicker"
                        v-model="preview.birthdate"
                        :active-picker.sync="activePicker"
                        :max="new Date().toISOString().substr(0, 10)"
                        :min="new Date(new Date().getFullYear() - 120, 0, 1).toISOString().substr(0, 10)"
                        locale="it-IT"
                        @change="saveBirthdate"
                      ></v-date-picker>
                    </v-menu>

                    <v-select
                      v-if="widgetConfig.showGender"
                      v-model="preview.gender"
                      label="Sesso"
                      :items="[
                        { text: 'Maschio', value: 'M' },
                        { text: 'Femmina', value: 'F' },
                        { text: 'Altro', value: 'O' }
                      ]"
                      outlined
                      dense
                      class="mb-2"
                      :rules="[v => !!v || 'Sesso richiesto']"
                    ></v-select>

                    <v-checkbox
                      v-model="preview.optIn"
                      class="mt-0"
                      :rules="[v => !!v || 'Devi accettare la privacy policy']"
                    >
                      <template v-slot:label>
                        <span class="text-caption black--text">
                          Accetto la <a :href="widgetConfig.privacyUrl || '#'" target="_blank" class="blue--text">privacy policy</a>
                        </span>
                      </template>
                    </v-checkbox>

                    <v-btn
                      block
                      :color="widgetConfig.buttonColor"
                      dark
                      class="mt-2"
                      @click="testSubmit"
                      :loading="preview.loading"
                    >
                      {{ widgetConfig.buttonText }}
                    </v-btn>

                    <v-alert
                      v-if="preview.success"
                      type="success"
                      dense
                      text
                      class="mt-3 mb-0"
                    >
                      Test riuscito! Il widget funziona correttamente.
                    </v-alert>

                    <v-alert
                      v-if="preview.error"
                      type="error"
                      dense
                      text
                      class="mt-3 mb-0"
                    >
                      {{ preview.errorMessage }}
                    </v-alert>
                  </v-form>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Subscribers List -->
          <v-col cols="12">
            <v-card class="neu-glow">
              <v-card-title class="text-h6 mb-3 blue white--text">
                Iscritti Newsletter ({{ subscribers.length }})
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Cerca"
                  single-line
                  hide-details
                  dense
                  outlined
                  dark
                  class="mr-2"
                  style="max-width: 300px;"
                ></v-text-field>
                <v-btn icon fab small class="neu-glow" @click="exportSubscribers">
                  <v-icon color="white">mdi-download</v-icon>
                </v-btn>
              </v-card-title>
              
              <v-data-table
                :headers="subscriberHeaders"
                :items="subscribers"
                :search="search"
                :loading="loading_subscribers"
                class="elevation-1"
                :footer-props="{
                  itemsPerPageOptions: [10, 25, 50, 100]
                }"
              >
                <template slot="item.birthdate" slot-scope="{ item }">
                  {{ formatDate(item.birthdate) }}
                </template>

                <template slot="item.email" slot-scope="{ item }">
                  <v-icon :color="item.email ? 'success' : 'error'">
                    {{ item.email ? 'mdi-check' : 'mdi-uncheck' }}
                  </v-icon>
                </template>             

                <template slot="item.created_at" slot-scope="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <!--
                <template slot="item.consent" slot-scope="{ item }">
                  <v-icon :color="item.consent ? 'success' : 'error'">
                    {{ item.consent ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </template>
              -->

                <template slot="item.actions" slot-scope="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon small @click="deleteSubscriber(item)">
                        <v-icon small color="error">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Elimina</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-form>

    <!-- Embed Code Dialog -->
    <v-dialog v-model="dialog_embed" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-h5 white--text">
          Codice di Integrazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon fab small @click="dialog_embed = false">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
        <!--
          <v-alert type="success" dense text class="mb-3">
            <strong>Configurazione Salvata!</strong> Ora puoi copiare il codice di integrazione.
          </v-alert>
        -->

          <!-- Platform Specific Instructions -->
          <v-tabs v-model="embedTab" background-color="blue" dark>
            <v-tab>
              <v-icon left>mdi-wordpress</v-icon>
              WordPress
            </v-tab>
            <v-tab>
              <v-icon left>mdi-web</v-icon>
              Wix
            </v-tab>
            <v-tab>
              <v-icon left>mdi-code-tags</v-icon>
              HTML
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="embedTab" class="mt-4">
            <!-- WordPress Tab -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <h3 class="mb-3">Istruzioni per WordPress</h3>
                  <ol class="text-body-2 mb-4">
                    <li>Vai su <strong>Aspetto → Widget</strong> o <strong>Aspetto → Personalizza → Widget</strong></li>
                    <li>Aggiungi un widget <strong>"HTML Personalizzato"</strong> o <strong>"Codice Personalizzato"</strong></li>
                    <li>Incolla il codice sottostante nel campo del contenuto</li>
                    <li>Salva le modifiche e pubblica</li>
                  </ol>
                  
                  <v-alert type="info" dense text class="mb-3">
                    <strong>Nota WordPress:</strong> Se usi un page builder (Elementor, WPBakery, etc.), 
                    puoi usare il modulo "HTML/Codice Personalizzato" del tuo builder.
                  </v-alert>
                  
                  <div class="d-flex align-center mb-2">
                    <h4>Codice da Copiare:</h4>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue" @click="copyEmbedCode('wordpress')">
                      <v-icon left small>mdi-content-copy</v-icon>
                      Copia Codice
                    </v-btn>
                  </div>
                  
                  <div class="code-block">
                    <pre>{{ embedCodeWordPress }}</pre>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Wix Tab -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <h3 class="mb-3">Istruzioni per Wix</h3>
                  <ol class="text-body-2 mb-4">
                    <li>Apri l'editor del tuo sito Wix</li>
                    <li>Clicca su <strong>"Aggiungi elementi" (+)</strong> nella barra laterale sinistra</li>
                    <li>Seleziona <strong>"Incorpora" → "Incorpora codice"</strong></li>
                    <li>Nella finestra che si apre, seleziona la scheda <strong>"Codice"</strong></li>
                    <li>Incolla il codice sottostante</li>
                    <li>Clicca su <strong>"Aggiorna"</strong> poi <strong>"Applica"</strong></li>
                    <li>Posiziona e ridimensiona il widget dove desideri nella pagina</li>
                    <li>Pubblica le modifiche</li>
                  </ol>
                  
                  <v-alert type="info" dense text class="mb-3">
                    <strong>Importante per Wix:</strong> Assicurati di impostare la dimensione del contenitore 
                    in modo appropriato (consigliato: larghezza 100%, altezza minima 500px per inline mode).
                  </v-alert>
                  
                  <div class="d-flex align-center mb-2">
                    <h4>Codice da Copiare:</h4>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue" @click="copyEmbedCode('wix')">
                      <v-icon left small>mdi-content-copy</v-icon>
                      Copia Codice
                    </v-btn>
                  </div>
                  
                  <div class="code-block">
                    <pre>{{ embedCodeWix }}</pre>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- HTML Tab -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <h3 class="mb-3">Istruzioni per Sito generico</h3>
                  <ol class="text-body-2 mb-4">
                    <li>Incolla il codice nel punto della tua pagina HTML dove vuoi che appaia il widget</li>
                    <li>Il widget verrà caricato automaticamente quando la pagina si carica</li>
                    <li v-if="widgetConfig.displayMode === 'inline'">Il widget apparirà inline nel punto dove lo hai inserito</li>
                    <li v-else-if="widgetConfig.displayMode === 'auto-popup'">Il popup apparirà automaticamente dopo {{ widgetConfig.popupDelay }} secondi</li>
                    <li v-else-if="widgetConfig.displayMode === 'button-popup'">Il widget creerà un pulsante che aprirà il popup</li>
                  </ol>
                                    
                  <div class="d-flex align-center mb-2">
                    <h4>Codice da Copiare:</h4>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue" @click="copyEmbedCode('html')">
                      <v-icon left small>mdi-content-copy</v-icon>
                      Copia Codice
                    </v-btn>
                  </div>
                  
                  <div class="code-block">
                    <pre>{{ embedCodeHTML }}</pre>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Instructions Dialog -->
    <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
        <v-card-title class="text-h5 blue white--text mb-3">
          Newsletter Widget: Istruzioni
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon fab small @click="dialog_instruction = false">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <h3 class="mb-2">Come funziona il Widget Newsletter</h3>
          <p>
            Il widget newsletter ti permette di raccogliere iscrizioni direttamente dal tuo sito web.
            I dati raccolti vengono salvati nel database e possono essere utilizzati per campagne marketing.
          </p>

          <h4 class="mt-4 mb-2">Modalità di Visualizzazione</h4>
          <ul>
            <li><strong>Inline:</strong> Il widget viene incorporato direttamente nella pagina nel punto dove inserisci il codice</li>
            <li><strong>Popup Automatico:</strong> Il widget appare in un popup modale dopo X secondi dal caricamento della pagina</li>
            <li><strong>Popup su Click:</strong> Il widget crea un pulsante flottante; quando l'utente clicca, si apre il popup</li>
          </ul>

          <h4 class="mt-4 mb-2">Configurazione</h4>
          <ol>
            <li>Seleziona la modalità di visualizzazione (clicca su uno dei tre pulsanti)</li>
            <li>Personalizza il titolo, descrizione e colori del widget</li>
            <li>Scegli se rendere l'email obbligatoria e se mostrare il campo sesso</li>
            <li>Salva la configurazione cliccando sull'icona del floppy disk</li>
            <li>Clicca su "Genera Codice di Integrazione"</li>
            <li>Scegli la piattaforma (WordPress, Wix o HTML) e copia il codice</li>
            <li>Incolla il codice nel tuo sito seguendo le istruzioni specifiche</li>
          </ol>

          <h4 class="mt-4 mb-2">Privacy e GDPR</h4>
          <p>
            Il widget include automaticamente un checkbox per il consenso al trattamento dati.
            Assicurati di avere una privacy policy valida e di inserire il link corretto nella configurazione.
          </p>

          <h4 class="mt-4 mb-2">Gestione Iscritti</h4>
          <p>
            Tutti gli iscritti vengono visualizzati nella tabella sottostante.
            Puoi cercare, filtrare ed esportare la lista in formato CSV per utilizzarla in altri strumenti di marketing.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="dialog_delete" max-width="500">
      <v-card>
        <v-card-title class="text-h5">Conferma Eliminazione</v-card-title>
        <v-card-text>
          Sei sicuro di voler eliminare l'iscritto <strong>{{ itemToDelete.firstName }} {{ itemToDelete.lastName }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_delete = false">Annulla</v-btn>
          <v-btn color="error" text @click="confirmDelete" :loading="loading_delete">Elimina</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import _ from 'lodash';

export default {
  data() {
    return {
      page: "Newsletter",
      snackbar: false,
      snackbar_color: null,
      snackbar_message: null,
      loading: false,
      loading_update: false,
      loading_subscribers: false,
      loading_delete: false,
      dialog_instruction: false,
      dialog_delete: false,
      dialog_embed: false,
      embedTab: 0,
      search: '',
      dateMenu: false,
      activePicker: null,
      user_id: null,
      privacyUrlValid: false,
      checkingPrivacyUrl: false,
                                    
    widgetCountryCodes: [
    { code: '+39', label: 'Italia (+39)', flag: '🇮🇹' },
    { code: '+1', label: 'USA/Canada (+1)', flag: '🇺🇸' },
    { code: '+44', label: 'UK (+44)', flag: '🇬🇧' },
    { code: '+33', label: 'Francia (+33)', flag: '🇫🇷' },
    { code: '+49', label: 'Germania (+49)', flag: '🇩🇪' },
    { code: '+34', label: 'Spagna (+34)', flag: '🇪🇸' },
    { code: '+41', label: 'Svizzera (+41)', flag: '🇨🇭' },
    { code: '+43', label: 'Austria (+43)', flag: '🇦🇹' },
    { code: '+351', label: 'Portogallo (+351)', flag: '🇵🇹' },
    { code: '+32', label: 'Belgio (+32)', flag: '🇧🇪' },
    { code: '+31', label: 'Paesi Bassi (+31)', flag: '🇳🇱' },
    { code: '+7', label: 'Russia (+7)', flag: '🇷🇺' },
    { code: '+86', label: 'Cina (+86)', flag: '🇨🇳' },
    { code: '+81', label: 'Giappone (+81)', flag: '🇯🇵' },
    { code: '+91', label: 'India (+91)', flag: '🇮🇳' },
    { code: '+55', label: 'Brasile (+55)', flag: '🇧🇷' },
    { code: '+61', label: 'Australia (+61)', flag: '🇦🇺' },
    { code: '+27', label: 'Sud Africa (+27)', flag: '🇿🇦' }
    ],            

      widgetConfig: {
        displayMode: 'inline',
        popupDelay: 5,
        title: 'Iscriviti alla Newsletter',
        description: 'Ricevi offerte esclusive e novità direttamente sul tuo WhatsApp',
        privacyUrl: '',
        buttonText: 'Iscriviti',
        buttonColor: '#1976D2',
        requireEmail: false,
        showGender: false,
        sendWAWhenSubscribe: false,
        body1: '',
        body2: '',
        body3: '',
        link: '',         
        active: true
      },
      config_hash: null,
      
      // Preview form data
      preview: {
        firstName: '',
        lastName: '',
        countryCode: '39',
        phone: '',
        email: '',
        birthdate: null,
        gender: '',
        optIn: false,
        loading: false,
        success: false,
        error: false,
        errorMessage: ''
      },
      
      subscribers: [],
      itemToDelete: {},
      
      subscriberHeaders: [
        { text: 'Nome', value: 'first_name' },
        { text: 'Cognome', value: 'last_name' },
        { text: 'WhatsApp', value: 'whatsapp' },
        { text: 'Email', value: 'email' },
        { text: 'Data Nascita', value: 'birthdate' },
        { text: 'Consenso', value: 'consent', align: 'center' },
        { text: 'Data Iscrizione', value: 'created_at' },
        { text: 'Azioni', value: 'actions', sortable: false, align: 'center' }
      ]
    };
  },
  
  computed: {
    ...mapGetters(["settings", "countries"]),
    
    formattedBirthdate() {
      if (!this.preview.birthdate) return '';
      const date = new Date(this.preview.birthdate);
      return date.toLocaleDateString('it-IT');
    },
            
    embedCodeWordPress() {
      const userId = this.settings.userid || 'YOUR_USER_ID';
      const displayMode = this.widgetConfig.displayMode;
      const popupDelay = this.widgetConfig.popupDelay;
      
      let code = `<script\n\tsrc="https://ibookrestaurant.com/widgets/newsletter/widget.js"\n\tcharset="UTF-8"\n\tdata-user-id="${userId}"`;
      
      if (displayMode !== 'inline') {
        code += `\n\tdata-display-mode="${displayMode}"`;
      }
      
      if (displayMode === 'auto-popup') {
        code += `\n\tdata-popup-delay="${popupDelay}"`;
      }
      
      code += `>\n<\/script>`;
      
      if (displayMode === 'inline') {
        code += `\n<div id="newsletter-widget"></div>`;
      }
      
      return code;
    },

    embedCodeWix() {
      const userId = this.settings.userid || 'YOUR_USER_ID';
      const displayMode = this.widgetConfig.displayMode;
      const popupDelay = this.widgetConfig.popupDelay;
      
      let code = `<script\n\tsrc="https://ibookrestaurant.com/widgets/newsletter/widget.js"\n\tcharset="UTF-8"\n\tdata-user-id="${userId}"`;
      
      if (displayMode !== 'inline') {
        code += `\n\tdata-display-mode="${displayMode}"`;
      }
      
      if (displayMode === 'auto-popup') {
        code += `\n\tdata-popup-delay="${popupDelay}"`;
      }
      
      code += `>\n<\/script>`;
      
      if (displayMode === 'inline') {
        code += `\n<div id="newsletter-widget" style="width: 100%; min-height: 500px;"></div>`;
      }
      
      return code;
    },

    embedCodeHTML() {
      const userId = this.settings.userid|| 'YOUR_USER_ID';
      const displayMode = this.widgetConfig.displayMode;
      const popupDelay = this.widgetConfig.popupDelay;
      
      let code = `<script\n\tsrc="https://ibookrestaurant.com/widgets/newsletter/widget.js"\n\tcharset="UTF-8"\n\tdata-user-id="${userId}"`;
      
      if (displayMode !== 'inline') {
        code += `\n\tdata-display-mode="${displayMode}"`;
      }
      
      if (displayMode === 'auto-popup') {
        code += `\n\tdata-popup-delay="${popupDelay}"`;
      }
      
      code += `>\n<\/script>`;
      
      if (displayMode === 'inline') {
        code += `\n<div id="newsletter-widget"></div>`;
      }
      
      return code;
    }
  },
  
  created() {
    this.getData();
    this.getSubscribers();
  },
  
  watch: {
    widgetConfig: {
      handler(newVal) {
        if (this.config_hash && this.config_hash !== JSON.stringify(newVal)) {
          // Config changed
        }
      },
      deep: true
    },
    dateMenu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  },
  
  methods: {
    async validatePrivacyUrl() {
      const url = this.widgetConfig.privacyUrl;
      
      // Check if URL is empty
      if (!url || url.trim() === '') {
        this.privacyUrlValid = false;
        this.snackbar_color = 'error';
        this.snackbar_message = 'URL della Privacy Policy è obbligatorio';
        this.snackbar = true;
        return false;
      }
      
      // Check if URL starts with https:// (http not allowed)
      if (!url.startsWith('https://')) {
        this.snackbar_color = 'error';
        this.snackbar_message = 'L\'URL della Privacy Policy deve iniziare con https://';
        this.snackbar = true;
        this.privacyUrlValid = false;
        return false;
      }
      
      // Check if URL is valid format
      try {
        new URL(url);
      } catch (e) {
        this.snackbar_color = 'error';
        this.snackbar_message = 'URL della Privacy Policy non valido';
        this.snackbar = true;
        this.privacyUrlValid = false;
        return false;
      }
      
      // All checks passed
      this.privacyUrlValid = true;
      this.snackbar_color = 'success';
      this.snackbar_message = 'URL della Privacy Policy valido';
      this.snackbar = true;
      return true;
    },
        
    async openEmbedDialog() {
      // Validate privacy URL before proceeding
      const isValid = await this.validatePrivacyUrl();
      
      if (!isValid) {
        return;
      }
      
      // Check if config needs to be saved
      if (this.config_hash !== JSON.stringify(this.widgetConfig)) {
        // Auto-save the configuration first
        this.snackbar_color = 'info';
        this.snackbar_message = 'Salvataggio configurazione in corso...';
        this.snackbar = true;
        
        // Call saveConfig instead of submit
        await this.saveConfig();
        
        // Check if save was successful by comparing hash again
        if (this.config_hash !== JSON.stringify(this.widgetConfig)) {
          // Save failed
          this.snackbar_color = 'error';
          this.snackbar_message = 'Errore nel salvataggio. Riprova.';
          this.snackbar = true;
          return;
        }
        
        this.snackbar_color = 'success';
        this.snackbar_message = 'Configurazione salvata con successo!';
        this.snackbar = true;
        
        // Wait a moment for user to see the message
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      
      // Open the embed dialog
      this.dialog_embed = true;
    },

    saveBirthdate(date) {
      this.$refs.birthdateMenu.save(date);
      this.dateMenu = false;
    },    
    validatePhone() {
      // Remove any non-numeric characters
      this.preview.phone = this.preview.phone.replace(/\D/g, '');
    },
    
    resetPreview() {
      this.preview = {
        firstName: '',
        lastName: '',
        countryCode: '+39',
        phone: '',
        email: '',
        birthdate: null,
        gender: '',
        optIn: false,
        loading: false,
        success: false,
        error: false,
        errorMessage: ''
      };
      if (this.$refs.previewForm) {
        this.$refs.previewForm.resetValidation();
      }
    },
    
    async testSubmit() {
      if (!this.$refs.previewForm.validate()) {
        this.preview.error = true;
        this.preview.errorMessage = 'Compila tutti i campi obbligatori';
        setTimeout(() => {
          this.preview.error = false;
        }, 3000);
        return;
      }
      
      this.preview.loading = true;
      this.preview.success = false;
      this.preview.error = false;
      
      // Simulate API call
      setTimeout(() => {
        this.preview.loading = false;
        this.preview.success = true;
        
        console.log('Preview form data:', {
          firstName: this.preview.firstName,
          lastName: this.preview.lastName,
          whatsapp: this.preview.countryCode + this.preview.phone,
          email: this.preview.email,
          birthdate: this.preview.birthdate,
          gender: this.preview.gender,
          optIn: this.preview.optIn
        });
        
        // Auto-hide success message and reset after 3 seconds
        setTimeout(() => {
          this.preview.success = false;
          this.resetPreview();
        }, 3000);
      }, 1000);
    },
        
    async getData(origin) {
      if (origin === 'refresh') {
        this.loading_refresh = true;
      } else {
        this.loading = true;
      }
      
      try {
        const payload = JSON.stringify({
          action: "Newsletter_Config_get"
        });
        
        const res = await this.$http.post('/settings/newsletter.php', payload);
        console.log('Newsletter config:', res);
        
        if (res.data.errorid === '0') {
          sessionStorage.setItem('jwt', res.data.jwt);
          
          if (res.data.payloads.config) {
            // Convert string values to proper types
            const config = res.data.payloads.config;
            this.widgetConfig = {
              displayMode: config.display_mode || this.widgetConfig.displayMode,
              popupDelay: config.popup_delay || this.widgetConfig.popupDelay,
              title: config.title || this.widgetConfig.title,
              description: config.description || this.widgetConfig.description,
              privacyUrl: config.privacy_url || this.widgetConfig.privacyUrl,
              buttonText: config.button_text || this.widgetConfig.buttonText,
              buttonColor: config.button_color || this.widgetConfig.buttonColor,
              requireEmail: config.require_email === '1' || config.require_email === true,
              showGender: config.require_gender === '1' || config.require_gender === true,
              sendWAWhenSubscribe: config.send_wa_when_subscribe === '1' || config.send_wa_when_subscribe === true,
              link: config.link || this.widgetConfig.link,
              body1: config.body1 || this.widgetConfig.body1,
              body2: config.body2 || this.widgetConfig.body2,
              body3: config.body3 || this.widgetConfig.body3,              
              active: config.active === '1' || config.active === true
            };
            this.user_id = config.user_id || null;
            this.config_hash = JSON.stringify(this.widgetConfig);
          }
        } else if (res.data.errorid === '0006') {
          this.$router.push('/auth/login').catch(() => {});
        }
      } catch (e) {
        console.error('Error loading newsletter config:', e);
        this.snackbar_color = 'error';
        this.snackbar_message = 'Errore caricamento configurazione';
        this.snackbar = true;
      } finally {
        this.loading = false;
        this.loading_refresh = false;
      }
    },
    
    async getSubscribers() {
      this.loading_subscribers = true;
      
      try {
        const payload = JSON.stringify({
          action: "Newsletter_Subscribers_get"
        });
        
        const res = await this.$http.post('/settings/newsletter.php', payload);
        console.log('Subscribers:', res);
        
        if (res.data.errorid === '0') {
          sessionStorage.setItem('jwt', res.data.jwt);
          this.subscribers = res.data.payloads.subscribers || [];
        }
      } catch (e) {
        console.error('Error loading subscribers:', e);
      } finally {
        this.loading_subscribers = false;
      }
    },
    
    async saveConfig() {
      this.loading_update = true;
      
      try {
        const payload = JSON.stringify({
          action: "Newsletter_Config_set",
          payload: {
            title: this.widgetConfig.title,
            description: this.widgetConfig.description,
            privacy_url: this.widgetConfig.privacyUrl,
            button_text: this.widgetConfig.buttonText,
            button_color: this.widgetConfig.buttonColor,
            require_email: this.widgetConfig.requireEmail ? 1 : 0,
            require_gender: this.widgetConfig.showGender ? 1 : 0,
            send_wa_when_subscribe: this.widgetConfig.sendWAWhenSubscribe?1:0,
            link: this.widgetConfig.link,
            body1:this.widgetConfig.body1,
            body2:this.widgetConfig.body2,
            body3:this.widgetConfig.body3,            
            active: this.widgetConfig.active ? 1 : 0
          }
        });
        
        const res = await this.$http.post('/settings/newsletter.php', payload);
        console.log('Save config result:', res);
        
        if (res.data.errorid === '0') {
          sessionStorage.setItem('jwt', res.data.jwt);
          this.config_hash = JSON.stringify(this.widgetConfig);
          this.snackbar_color = 'success';
          this.snackbar_message = 'Configurazione salvata con successo';
          this.snackbar = true;
        } else {
          this.snackbar_color = 'error';
          this.snackbar_message = res.data.message || 'Errore salvataggio';
          this.snackbar = true;
        }
      } catch (e) {
        console.error('Error saving config:', e);
        this.snackbar_color = 'error';
        this.snackbar_message = 'Errore salvataggio configurazione';
        this.snackbar = true;
      } finally {
        this.loading_update = false;
      }
    },
    
    copyEmbedCode(platform) {
      let code = '';
      if (platform === 'wordpress') {
        code = this.embedCodeWordPress;
      } else if (platform === 'wix') {
        code = this.embedCodeWix;
      } else if (platform === 'html') {
        code = this.embedCodeHTML;
      }
      
      // Create temporary textarea to copy
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      
      this.snackbar_color = 'success';
      this.snackbar_message = 'Codice copiato negli appunti';
      this.snackbar = true;
    },
    
    deleteSubscriber(item) {
      this.itemToDelete = item;
      this.dialog_delete = true;
    },
    
    async confirmDelete() {
      this.loading_delete = true;
      
      try {
        const payload = JSON.stringify({
          action: "Newsletter_Subscriber_delete",
          payload: { id: this.itemToDelete.id }
        });
        
        const res = await this.$http.post('/settings/newsletter.php', payload);
        
        if (res.data.errorid === '0') {
          sessionStorage.setItem('jwt', res.data.jwt);
          this.subscribers = this.subscribers.filter(s => s.id !== this.itemToDelete.id);
          this.snackbar_color = 'success';
          this.snackbar_message = 'Iscritto eliminato';
          this.snackbar = true;
          this.dialog_delete = false;
        } else {
          this.snackbar_color = 'error';
          this.snackbar_message = res.data.message || 'Errore eliminazione';
          this.snackbar = true;
        }
      } catch (e) {
        console.error('Error deleting subscriber:', e);
        this.snackbar_color = 'error';
        this.snackbar_message = 'Errore eliminazione iscritto';
        this.snackbar = true;
      } finally {
        this.loading_delete = false;
      }
    },
    
    exportSubscribers() {
      // Create CSV
      const headers = ['Nome', 'Cognome', 'WhatsApp', 'Email', 'Data Nascita', 'Sesso', 'Data Iscrizione'];
      const rows = this.subscribers.map(s => [
        s.firstName,
        s.lastName,
        s.whatsapp,
        s.email || '',
        this.formatDate(s.birthdate),
        s.gender || '',
        this.formatDateTime(s.createdAt)
      ]);
      
      let csvContent = headers.join(',') + '\n';
      rows.forEach(row => {
        csvContent += row.map(cell => `"${cell}"`).join(',') + '\n';
      });
      
      // Download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `newsletter_iscritti_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.snackbar_color = 'success';
      this.snackbar_message = 'Esportazione completata';
      this.snackbar = true;
    },
    
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('it-IT');
    },
    
    formatDateTime(datetime) {
      if (!datetime) return '';
      return new Date(datetime).toLocaleString('it-IT');
    }
  }
};
</script>

<style scoped>

.code-block {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
  overflow-x: auto;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.code-block pre {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  word-wrap: break-word;
}



.newsletter-preview {
  max-width: 450px;
  margin: 0 auto;
  background-color: #ffffff;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* Force outlined borders to show in preview */
.newsletter-preview >>> .v-text-field--outlined fieldset,
.newsletter-preview >>> .v-select--outlined fieldset {
  border-color: rgba(0, 0, 0, 0.38) !important;
  border-width: 1px !important;
}

.newsletter-preview >>> .v-text-field--outlined:hover fieldset,
.newsletter-preview >>> .v-select--outlined:hover fieldset {
  border-color: rgba(0, 0, 0, 0.87) !important;
}

.newsletter-preview >>> .v-text-field--outlined.v-input--is-focused fieldset,
.newsletter-preview >>> .v-select--outlined.v-input--is-focused fieldset {
  border-color: #1976D2 !important;
  border-width: 2px !important;
}

.newsletter-preview >>> .v-text-field--outlined .v-label,
.newsletter-preview >>> .v-select--outlined .v-label {
  background-color: #ffffff !important;
  padding: 0 4px !important;
}

.newsletter-preview >>> .v-text-field__slot input,
.newsletter-preview >>> .v-select__slot input,
.newsletter-preview >>> .v-text-field__slot textarea {
  color: #000000 !important;
}

.newsletter-preview >>> .v-input__slot {
  background-color: #ffffff !important;
}

.newsletter-preview >>> .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}

.code-textarea >>> textarea {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  background-color: #f5f5f5 !important;
  color: #000000 !important;
}

.code-textarea >>> .v-text-field__slot textarea {
  color: #000000 !important;
}

/* Fix checkbox visibility in preview */
.newsletter-preview >>> .v-input--checkbox {
  margin-top: 0 !important;
}

.newsletter-preview >>> .v-input--selection-controls__input {
  margin-right: 8px !important;
}

.newsletter-preview >>> .v-input--checkbox .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 18px !important;
}

.newsletter-preview >>> .v-input--checkbox .v-input--is-label-active .v-icon {
  color: #1976D2 !important;
}

.newsletter-preview >>> .v-input--checkbox .mdi-checkbox-blank-outline::before {
  content: "\F0131" !important;
}

.newsletter-preview >>> .v-input--checkbox .mdi-checkbox-marked::before {
  content: "\F0132" !important;
}

/* Fix tab visibility - selected tab text should be black on blue background */
.v-tabs >>> .v-tab--active {
  color: #000000 !important;
  font-weight: bold;
}

.v-tabs >>> .v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
}

.v-tabs >>> .v-tabs-slider {
  background-color: #000000 !important;
  height: 3px !important;
}
</style>